/**
 * Stage name constants
 */
export enum STAGE {
  TEST = 'test',
  ALPHA = 'alpha',
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}

export const getCurrentStage = (): STAGE => {
  return '{{Stage}}' as STAGE;
};
